import React, { useEffect, useState } from 'react'
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import Loader from '../../../component/Loader/Loader';
import Breadcrumb from '../../../component/Breadcrumb';
import MappingMessageTable from './MappingMessageTable';
import MappingTabing from '../../../component/MappingTabing';
import { Box, Button, Grid, TextField, Typography } from '@mui/material';
import { getDataForExistingMessage } from '../../../api/mappingApi';
import { checklocalStorageItems, compareChanges, saveContentFile } from '../../../utlis';
import CanMappingTabing from '../../../component/CanMappingTabing';
import PageTabing from '../../../component/PageTabing';


const MappingReceiveMessages = () => {

    const [showLoader, setShowLoader]                       =   useState(false);
    const [messageData,setMessageData]                      =   useState([]);
    const [searchValue,setSearchValue]                      =   useState('');
    const [itemForLocal, setItemForLocal]                   =   useState(false);
    const [lengthCount, setLengthCount]                     =   useState(0);
    const [previousHash,setPreviousHash]   = useState(() => {
        const storedMessages =  localStorage.getItem('ECUReceiveMessages');
        return storedMessages ? storedMessages : '';
    })

    useEffect(() => {
        const dataInLocalStorage = checklocalStorageItems();
        setItemForLocal(dataInLocalStorage);
        fetchMessageData();
        window.addEventListener('storage',fetchMessageData);
        return () => {
            window.removeEventListener('storage',fetchMessageData);
        }
    },[lengthCount,previousHash]);
      
    
    const fetchMessageData = async () => {
        let localStorageMessageData = JSON.parse(localStorage.getItem('ECUReceiveMessages'));
        const newHash = (localStorageMessageData != null && localStorageMessageData.length > 0) ? JSON.stringify(localStorageMessageData) : '';
        if(localStorageMessageData != null && localStorageMessageData.length > 0){
            setLengthCount(localStorageMessageData.length);    
            if(localStorageMessageData.length !== lengthCount || previousHash !== newHash ){
                const formData = new FormData();
                const jsonData = JSON.stringify(localStorageMessageData);
                formData.append('file',new Blob([jsonData],{type:'application/json'}),'data.txt');
                setShowLoader(true);
                let fetchDataForExisiting = await getDataForExistingMessage(formData);
                setShowLoader(false);
                setPreviousHash(newHash);
                if(fetchDataForExisiting){
                    setMessageData(fetchDataForExisiting);
                }
            }
        }
    }

    
    const handleRowDelete = (rowIndex) => {
        const newArray = [...messageData];
        newArray.splice(rowIndex, 1);
        setMessageData(newArray);
        if(newArray.length === 0){
            localStorage.removeItem("ECUReceiveMessages");
        } else {
            localStorage.setItem('ECUReceiveMessages',JSON.stringify(newArray));
        }
        const storedMessages =  localStorage.getItem('ECUReceiveMessages');
        setPreviousHash(storedMessages ? storedMessages : '');
    }
    
    const handleAddButton = () => {
        window.open('/can/receive-messages','_blank','noopener,noreferrer,width=auto,height=auto')
    } 
    
    const handleChangeTextValue = (e) => {
        setSearchValue(e.target.value)
    }
    
    const handleSearch = async () => {
        setShowLoader(true);
        let localStorageMessageData = JSON.parse(localStorage.getItem('ECUReceiveMessages'));
        if(localStorageMessageData != null && localStorageMessageData.length > 0){
            const formData = new FormData();
            const jsonData = JSON.stringify(localStorageMessageData);
            formData.append('file',new Blob([jsonData],{type:'application/json'}),'data.txt')
            let fetchDataForExisiting = await getDataForExistingMessage(formData);
            setShowLoader(false);
            if(fetchDataForExisiting){
                if(searchValue !== ''){
                    let filterResults = fetchDataForExisiting.filter((data) => data.EnglishText === searchValue);
                    setMessageData(filterResults);
                } else {
                    setMessageData(fetchDataForExisiting);
                }
            }
        }
        setShowLoader(false);
    }
    
    const clearSearchValue = () => {
        setSearchValue('')
        fetchMessageData();
    }
    
    const handleConfigFileContent = async() => {
        setShowLoader(true);
        const result = await saveContentFile();
        setShowLoader(false);
        if(result){
            swal({
              title: "Success",
              text: result.message,
              icon: "success",
            })
        }
    }

    return (
        <>
            {showLoader &&
                <Loader />
            }
            <Breadcrumb  title="ECU Receive Messages">
                <Typography component={Link} to="/" color="primary" variant="subtitle2"  className="link-breadcrumb">
                Dashboard
                </Typography>
                <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
                CAN
                </Typography>
            </Breadcrumb>
            <MappingTabing 
                    value="can" 
                    handleConfigFileContent={handleConfigFileContent}      
            />
            <Box  component="section">
                <Grid className="contentBox">
                <CanMappingTabing value="receive-messages" /> 
                <Grid className="modbusButtons" container direction="row" display={'flex'} justifyContent={'space-between'}>
                    <Grid item>
                        <Box sx={{ ml:4,display: 'flex', alignItems: 'flex-end'}}>
                            <TextField id="input-with-sx" value={searchValue} label="Search By English Text" variant="standard" onChange={handleChangeTextValue} />
                            <SearchIcon onClick={handleSearch} sx={{cursor:'pointer', color: '#74737B', mr: 0.5,my: 0.5  }} />
                            <ClearIcon onClick={clearSearchValue} sx={{cursor:'pointer', color: '#FF413A', my: 0.5 }} />
                        </Box>
                    </Grid>
                    {itemForLocal &&
                    <Grid item sx={{mt: { xs: 2,sm:1 },pl: { xs: 4 }}}>
                        <Button
                            onClick={handleAddButton}
                            variant="contained"
                            size="small"
                            color="primary"
                            sx={{mr:3}}
                        >Add 
                        </Button>
                    </Grid>
                    }
                </Grid>
                {messageData.length === 0  &&
                    <p>No Data Available.</p>
                }
                <MappingMessageTable 
                    data={messageData}
                    handleRowDelete={handleRowDelete}
                    setShowLoader={setShowLoader}
                />
                </Grid>
            </Box>
        </>
    )
}

export default MappingReceiveMessages